import cartConfig from "emun.cart/cart.config";
import CartController from "emun.cart/cart.controller";
import required from "emun.order/_required";
import orderConfig from "emun.order/order.config";
import AutoQuery from "servicestack/auto-query/auto-query";
// import moment from "moment";
import views from "emun.cart/checkout/checkout.views";
import CustomerCleanupPrompt from "emun.customer/cleanup/customer-cleanup-prompt";
import OrderDetailsPrompt from "emun.order/order-details-prompt";
import formSubmissionPrompt from "emun.retailer/retailer-form-submission-prompt";
import docCookies from "webutils/services/doc-cookies";
import { replaceSpaces } from "webutils/services/util";
import resolve from "ioc/resolve";
import ContactPrompt from 'emun.customer/contact-prompt'

const $localStorage = resolve("$localStorage");

export default class CheckoutController extends CartController {
  constructor($cart) {
    super($cart);
    const $ctrl = this;
    $ctrl.required = required;
    $ctrl.views = views;
    $ctrl.today = moment();
    $ctrl.online = window.navigator.onLine;
    $ctrl.minDate = moment.utc().startOf("day");
    $ctrl.orderConfig = orderConfig;
    $ctrl.cartConfig = cartConfig;
    $ctrl.cybersourcePending = false;
    $ctrl.replaceSpaces = replaceSpaces;
    if ($ctrl.$session.isShowroom()) {
      $cart.bus.send("QueryPrinters.json").then((res) => {
        $ctrl.printers = res.data.results.map((o) => o.printerName);
      });
    }
    if (cartConfig.shipDateDays) {
      $ctrl.minDate = moment
        .utc()
        .startOf("day")
        .add(cartConfig.shipDateDays, "day");
    }
    if ($ctrl.$session.salesManagementMode) {
      $ctrl.$on("cartRemoved", (e, cart) => $ctrl.exitOrder(cart.id));
      $ctrl.$on("orderActivitySaved", (e, args) =>
        $ctrl.loadOrderActivities(args.data.id)
      );
    }

    let shared_token = docCookies.getItem("shared_token");
    let shared_cart_id = docCookies.getItem("shared_cart_id");
    if ($ctrl.token && $ctrl.token != "undefined") {
      $ctrl.$cart.load($ctrl.cartId, $ctrl.token);
      docCookies.setItem("shared_cart_id", $ctrl.cartId);
      docCookies.setItem("shared_token", $ctrl.token);
    } else if (shared_token) {
      $ctrl.token = shared_token;
      $ctrl.cartId = shared_cart_id;
      $ctrl.$cart.load(shared_cart_id, shared_token);
    }

    $ctrl.$cart.$$load.then(() => {
      if ($ctrl.$cart.purchaser && $ctrl.$cart.purchaser.email)
        $ctrl.emails = $ctrl.$cart.purchaser.email.split(",");
      if ($ctrl.$cart.reviewedBy)
        $ctrl.shareWith = $ctrl.$cart.reviewedBy.split(",");
      $ctrl.$cart.removeOrderFromSession($ctrl.$cart.id);

      $ctrl.$cart.bus
        .send("QueryRetailers.json?Id=" + $ctrl.$cart.retailerId)
        .then(function (res) {
          if (res.data.results.length > 0) {
            $ctrl.retailer = res.data.results[0];
            if (
              $ctrl.$session.isRepOrAbove() &&
              cartConfig.customerCleanup &&
              !$ctrl.retailer.infoReviewed
            ) {
              CustomerCleanupPrompt.open({ retailerId: $ctrl.retailer.id });
            }
          }
        });
      $ctrl.termsQuery = new AutoQuery({
        url: `QueryPaymentTerms.json?cartId=` + $cart.id,
        take: 1000,
        autoLoad: true,
        orderBy: "Name",
      });
      $ctrl.locations = new AutoQuery({
        url:
          $cart.purchaser &&
          "QueryRetailerShippingLocations.json?retailerId=" + $cart.retailerId,
        orderBy: "Name",
        autoLoad: !!$cart.purchaser,
        pageSize: 500,
      });
      $ctrl.usersQuery = new AutoQuery({
        url:
          $cart.purchaser &&
          "QueryUsers.json?active=true&retailerId=" + $cart.retailerId,
        orderBy: "FullName",
        autoLoad: !!$cart.purchaser,
        pageSize: 500,
        onLoaded: function (args) {
          $ctrl.users = args.results.filter(function (obj) {
            return obj.email !== "";
          });
        },
      });
      $ctrl.contacts = new AutoQuery({
        url:
          $cart.purchaser &&
          "QueryRetailerContacts.json?active=true&retailerId=" + $cart.retailerId,
        orderBy: "Name",
        autoLoad: !!$cart.purchaser,
        pageSize: 500,
        onLoaded: function (args) {
          $ctrl.contactsWithEmail = args.results.filter(function (obj) {
            return obj.email !== "" && obj.email !== null;
          });
          //add the email from order if it isn't a contact
          if ($ctrl.emails) {
            $ctrl.emails.forEach(function (email) {
              var orderEmail = $ctrl.contactsWithEmail.filter(function (obj) {
                return obj.email === email;
              });

              if (
                orderEmail === null ||
                (orderEmail.length === 0 && email && email !== "")
              ) {
                var contact = {
                  name: "no name",
                  email: email,
                };
                $ctrl.contactsWithEmail.push(contact);
              }
            });
          }
        },
      });
      $ctrl.shippingMethods = new AutoQuery({
        url:
          $cart.purchaser &&
          "QueryShippingMethods.json?retailerId=" + $cart.retailerId,
        criteria: {
          vendorId: $cart.vendorId,
        },
        orderBy: "Name",
        autoLoad: !!$cart.purchaser,
        pageSize: 150,
      });

      $ctrl.sources = new AutoQuery({
        url: "QueryOrderSources.json",
        autoLoad: true,
        criteria: {
          op: "OrderHeaderFieldset",
        },
        take: 1000,
      });
      $ctrl.showcodes = new AutoQuery({
        url: "QueryShowCodes.json",
        autoLoad: true,
        criteria: {
          op: "OrderHeaderFieldset",
        },
        take: 1000,
      });
      $ctrl.showVendorLocations = new AutoQuery({
        url: "QueryShowVendorLocations.json",
        autoLoad: true,
        criteria: {
          op: "OrderHeaderFieldset",
          showCodeId: $ctrl.$cart.showCodeId,
          vendorId: $ctrl.$cart.vendorId,
        },
        take: 1000,
      });

      this.loadOrderActivities("");
      !cartConfig.hidePromoStatus && $cart.checkPromos($cart.id);

      //validate pricing
      if (cartConfig.repriceCartOnCheckout) {
        $ctrl.bus
          .send("RepriceCart.json?CartId=" + $ctrl.$cart.id)
          .then(function (res) {
            $ctrl.$cart.load($ctrl.cartId, $ctrl.token);
            if (cartConfig.repriceCartMessage) {
              if (res.data.pricingChange) {
                modals.alert(cartConfig.repriceCartMessage);
              }
            }
          });
      }
      $ctrl.maxCancelDate = moment
        .utc($ctrl.$cart.shipOn)
        .add($ctrl.cartConfig.maxCancelDaysAfterShip, "days");
    });
    $ctrl.$on("promoApplied", () => $ctrl.termsQuery.load(true));
    $ctrl.$on("contactSaved", () => $ctrl.contacts.load(true));
    $ctrl.$on("cartLoaded", () => {
      if ($cart.shipOn && $cart.shipOn.format)
        $cart.shipOnMoment = $cart.shipOn.format(cartConfig.dateFormat);
      if ($cart.cancelOn && $cart.cancelOn.format)
        $cart.cancelOnMoment = $cart.cancelOn.format(cartConfig.dateFormat);
      $ctrl.maxCancelDate = moment
        .utc($ctrl.$cart.shipOn)
        .add($ctrl.cartConfig.maxCancelDaysAfterShip, "days");
    });
    if (
      cartConfig.combineFutureShipDates &&
      !$ctrl.$session.isSalesManagementMode()
    )
      $ctrl.combineFutureShipDates();
  }

  loadOrderActivities(activityId) {
    const $ctrl = this;
    //console.info("activityId", activityId);
    if (activityId && activityId != "") {
      $ctrl.$cart.activityId = activityId;
      $ctrl.$cart.updateOrderActivity("activityId");
    }

    $ctrl.orderActivities = new AutoQuery({
      url:
        $ctrl.$cart.purchaser &&
        "QueryActivitiesJoin.json?Fields=id,title,type,startdate,enddate",
      criteria: {
        RetailerId: $ctrl.$cart.retailerId,
        SinceStartDate: moment($ctrl.$cart.orderedOn)
          .add("days", -7)
          .format("MM/DD/YYYY"),
        ShowCode:
          $ctrl.$session.isShowroom() && $ctrl.$cart.showCode
            ? $ctrl.$cart.showCode.name
            : null,
      },
      orderBy: "StartDate",
      autoLoad: !!$ctrl.$cart.purchaser,
      pageSize: 50,
      onLoaded(args) {
        if (args.results.length == 1) {
          $ctrl.$cart.activityId = args.results[0].id;
          $ctrl.$cart.updateOrderActivity("activityId");
        }
        $ctrl.activities = args.results.filter(function (obj) {
          return obj.type !== "" && obj.title !== null;
        });
        //add the email from order if it isn't a contact
        //console.info("cartConfig.orderActivityTypes", cartConfig.orderActivityTypes);
        cartConfig.orderActivityTypes.forEach(function (oa) {
          var activity = {
            id: oa.id,
            title: oa.item,
            type: oa.type,
          };
          $ctrl.activities.unshift(activity);
        });
        console.info("$ctrl.activities", $ctrl.activities);
        console.info(
          "cartConfig.orderActivityTypes",
          cartConfig.orderActivityTypes
        );
        $ctrl.$cart.activities = $ctrl.activities;
      },
    });
  }

  updateRetailer() {
    var $ctrl = this;
    $ctrl.$cart.editBilling().then((l) => {
      //console.debug("still here");
      $ctrl.$broadcast("billingUpdated", {});
      $ctrl.emails = $ctrl.$cart.purchaser.email.split(",");

      if ($ctrl.emails) {
        $ctrl.emails.forEach(function (email) {
          var orderEmail = $ctrl.contactsWithEmail.filter(function (obj) {
            return obj.email === email;
          });

          if (
            orderEmail === null ||
            (orderEmail.length === 0 && email && email !== "")
          ) {
            var contact = {
              name: "no name",
              email: email,
            };
            $ctrl.contactsWithEmail.push(contact);
          }
        });
      }
    });
  }

  isRegionalLoginMode() {
    return this.$session.meta.LoginMode === "Regional";
  }
  toggleCheckoutCollapse() {
    const element = document.getElementById("checkout-collapse-grid");
    if (element) {
      element.classList.toggle("in");
    }
  }
  edit() {
    const $ctrl = this;
    OrderDetailsPrompt.open({
      order: $ctrl.$cart,
      mode: "Order",
      nextRoute: resolve("$state").current.name || "checkout",
    }).then(() =>
      $ctrl.$cart.load($ctrl.cartId, $ctrl.token).then(() => {
        var cart = $ctrl.$cart;
        $ctrl.$broadcast("updateOrderApplied", {
          cart,
          $ctrl,
        });
      })
    );
  }

  parseEmail(item, model) {
    let $ctrl = this;
    $ctrl.$cart.purchaser.email = $ctrl.emails.join(",");
    $ctrl.$cart.update("PurchaserEmail");
  }

  parseShareWith(item, model) {
    let $ctrl = this;
    $ctrl.$cart.reviewedBy = $ctrl.shareWith.join(",");
    $ctrl.$cart.update("ReviewedBy");
  }

  addEmail(search) {
    let $ctrl = this;
    var contact = {
      name: "no name",
      email: search,
    };
    return contact;
  }

  goToOrder() {
    let $ctrl = this;
    $ctrl.$cart.load($ctrl.cartId, $ctrl.token);
    $ctrl.$cart.view();
  }

  exitOrder(OrderID) {
    let $ctrl = this;
    let orderId = OrderID !== undefined ? OrderID : $ctrl.order.id;
    $ctrl.$cart.exitOrder(orderId, true);
    $ctrl.query.load(true);
  }

  showcodeSelected() {
    const $ctrl = this;
    $ctrl.showVendorLocations.filter("showCodeId", $ctrl.$cart.showCodeId);
    $ctrl.$cart.update("showCodeId");
  }

  showVendorLocationSelected() {
    const $ctrl = this;
    $ctrl.$cart.update("location");
  }

  sourceSelected() {
    const $ctrl = this;
    $ctrl.$cart.update("sourceId");
  }
  applyForTerms(formId, termId) {
    const $ctrl = this;
    $ctrl.selectedForm = {};
    $ctrl.formSubmitted = false;
    $ctrl.submission = {};

    formSubmissionPrompt(
      Object.assign({
        title: "Form Submission...",
        FormId: formId,
        RefId: $ctrl.$cart.retailerId,
      })
    ).then(function (res) {
      if (res) {
        $ctrl.$cart
          .applyPaymentTerms({ paymentTermsId: termId })
          .then(function () {
            location.reload();
          });
      }
    });
  }
  updateShipDate(shipDate) {
    let $ctrl = this;
    let request = {
      cartId: $ctrl.$cart.id,
      key: null,
      shipOn: shipDate,
      token: $ctrl.token,
    };
    return $ctrl.$cart.bus
      .send("UpdateCartItemShipDate.json", request)
      .then(function (response) {
        if (!response.data.exceptions) {
          $ctrl.$cart.load($ctrl.cartId, $ctrl.token);
        }
      });
  }

  combineFutureShipDates() {
    let $ctrl = this;
    return $ctrl.$cart.bus
      .send("CombineFutureShipDates.json", {
        cartId: $ctrl.$cart.id,
      })
      .then(function (response) {
        if (response.data.shipDatesCombined) location.reload();
      });
  }

  createContact() {
		const $ctrl = this;
        ContactPrompt.open({ model: { customer: $ctrl.retailer } });
  }

  updateCancelDate(cancelDate) {
    let $ctrl = this;
    let request = {
      cartId: $ctrl.$cart.id,
      key: null,
      cancelOn: cancelDate,
    };
    return $ctrl.$cart.bus
      .send("UpdateCartItemCancelDate.json", request)
      .then(function (response) {
        if (!response.data.exceptions) {
          $ctrl.$cart.load($ctrl.cartId, $ctrl.token);
        }
      });
  }
}
